import CustomTag from 'components/CustomTag'
import {
  RowNumberDataReport,
  RowNumberDataReportAlignCenter,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import {
  DateFormat,
  arrayIntoString,
} from 'modules/Report/CommonFunction/Function.js'
import { CandidateApplicationTitle } from 'modules/Report/ExcelHeaderData.js'
import PageContent from 'modules/Report/Partials/CommonTable/PageContent.js'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import WarningMessage from 'utils/WarningMessage'
import { permittedSubEvents } from '../../../../utils/permissionsValidation'
import { serialNo } from '../../CommonFunction/Function'
import { setCandidateApplicationStatus } from '../../action'
const CandidateApplication = ({
  cityData,
  cityDetails,
  tierDetails,
  tierData,
  getCandidateApplicationStatus,
  rolesPublishedData,
  excelDataForReport,
  collegeDetails,
  roleDetails,
  collegeData,
  roleData,
  corporateData,
}) => {
  const dispatch = useDispatch()
  const [dateError, setDateError] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [excelLoading, setExcelLoading] = useState(false)
  const [loadingTier, setLoadingTier] = useState(false)
  const [loadingRole, setLoadingRole] = useState(false)
  const [loadingRoleFilter, setLoadingRoleFilter] = useState(false)
  const [loadingCollegeFilter, setLoadingCollegeFilter] = useState(false)
  const [searchTierValue, setSearchTierValue] = useState('')
  const [searchRoleValue, setSearchRoleValue] = useState('')
  const [searchCollegeValue, setSearchCollegeValue] = useState('')
  const [tierValue, setTierValue] = useState([])
  const [cityValue, setCityValue] = useState([])
  const [roleValue, setRoleValue] = useState([])
  const [collegeValue, setCollegeValue] = useState([])
  const [debounced, setDebounced] = useState(() => roleNameValue)
  const [createdAtStart, setCreatedAtStart] = useState('')
  const [offerRaisedFilter, setOfferRaisedFilter] = useState('')
  const [offerAppliedFilter, setOfferAppliedFilter] = useState('')
  const [lastDate, setLastDate] = useState('')
  const [clearJoiningDate, setClearJoiningDate] = useState(false)
  const [createdAtEnd, setCreatedAtEnd] = useState('')
  const [appendDateFilter, setAppendDateFilter] = useState([])
  const [clearDate, setClearDate] = useState(false)
  const [roleNameValue, setRoleNameValue] = useState()
  const [filterData, setFilterData] = useState({
    tier: '',
    job: '',
    college: '',
    createdAtEnd: '',
    createdAtStart: '',
    appenddate: '',
    offered: '',
    accepted: '',
  })
  const [tooltip, setTooltip] = useState(false)
  const [sortBy, setSortBy] = useState({
    orderBy: 'desc',
    sortName: 'end_date',
  })
  const [isExcel, setIsExcel] = useState('')
  const [excel, setExcel] = useState([])
  const [previousPage, setPreviousPage] = useState('')
  const onPageChange = pageNum => {
    setPreviousPage(currentPage)
    setCurrentPage(pageNum)
  }
  function hasData(obj) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] !== '') {
        return true
      }
    }
    return false
  }
  useEffect(() => {
    dispatch(setCandidateApplicationStatus())
  }, [])
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebounced(roleNameValue)
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [roleNameValue])

  const clearFilter = () => {
    setCityValue([])
    setTierValue([])
    setCollegeValue([])
    setRoleValue([])
    setCreatedAtStart('')
    setCreatedAtEnd('')
    setSearchCollegeValue('')
    setLastDate('')
    setOfferRaisedFilter('')
    setOfferAppliedFilter('')
    setRoleNameValue('')
    setSearchTierValue('')
    setSearchRoleValue('')
    setClearJoiningDate(true)
    setClearDate(true)
    setFilterData({ tier: '', city: '' })
    dispatch(setCandidateApplicationStatus())
  }
  const applyFilter = () => {
    let filterData = {
      tier: arrayIntoString(tierValue),
      college: arrayIntoString(collegeValue),
      role: arrayIntoString(roleValue),
      createdAtStart: createdAtStart,
      createdAtEnd: createdAtEnd,
      appenddate: lastDate,
      offered: arrayIntoString(offerRaisedFilter),
      accepted: arrayIntoString(offerAppliedFilter),
    }
    if (createdAtStart) {
      if (!createdAtEnd) {
        WarningMessage(
          <>
            Kindly select <q>To Date</q> from Date Range
          </>
        )
      }
    }
    if (createdAtEnd) {
      if (!createdAtStart) {
        WarningMessage(
          <>
            Kindly select <q>From date</q> from Date Range
          </>
        )
      }
    }
    if (createdAtEnd && createdAtStart && !dateError) {
      setFilterData(filterData)
    }
    if (!createdAtEnd && !createdAtStart && !dateError) {
      setFilterData(filterData)
    }
    if (dateError) {
      setTooltip(true)
      WarningMessage(<>Kindly check the error in filter</>)
    }
  }
  useEffect(() => {
    if (dateError) {
      setTooltip(true)
    }
  }, [dateError])
  const tableData = excelDataForReport?.result?.map((item, index) => [
    {
      value: index + 1,
    },
    {
      value: item.tittle ? item.tittle : '-',
    },

    { value: item.totaldrive ? item.totaldrive : '0' },
    { value: item.end_date ? DateFormat(item.end_date) : '-' },
    {
      value: item.campus_name ? item.campus_name : '-',
    },
    {
      value: item.tier?.toString() ? item.tier : '-',
    },
    { value: item.totalstudent ? Number(item.totalstudent) : '0' },
    { value: item.avgrating ? Number(item.avgrating)?.toFixed(2) : '0' },
    { value: item.offerreleased ? Number(item.offerreleased) : '0' },
    { value: item.offeraccepted ? Number(item.offeraccepted) : '0' },
  ])
  const excelData = [{ columns: CandidateApplicationTitle, data: tableData }]
  const onSorting = (pagination, row, sorter) => {
    let order = 'desc'
    let sort = sorter.field
    if (sorter.order === 'descend') {
      //
    } else if (sorter.order === 'ascend') {
      order = 'asc'
    } else {
      sort = 'end_date'
    }
    let sortBy = {
      orderBy: order,
      sortName: sort,
    }
    setSortBy(sortBy)
  }

  useEffect(() => {
    if (hasData(filterData)) {
      if (currentPage) {
        if (hasData(filterData))
          getCandidateApplicationStatus(
            10,
            currentPage,
            setLoadingRole,
            roleNameValue,
            filterData,
            sortBy
          )
      }
    }
  }, [currentPage])
  useEffect(() => {
    if (hasData(filterData))
      getCandidateApplicationStatus(
        10,
        1,
        setLoadingRole,
        roleNameValue,
        filterData,
        sortBy
      )
    setCurrentPage(1)
  }, [filterData, debounced, sortBy])
  useEffect(() => {
    setTierValue([])
  }, [])
  useEffect(() => {
    let filterData = {
      tier: arrayIntoString(tierValue),
      city: arrayIntoString(cityValue),
      college: arrayIntoString(collegeValue),
      role: arrayIntoString(roleValue),
      createAtStart: createdAtStart,
      createAtEnd: createdAtEnd,
      appenddate: lastDate,
      offered: arrayIntoString(offerRaisedFilter),
      accepted: arrayIntoString(offerAppliedFilter),
    }

    setTooltip(hasData(filterData))
  }, [
    offerRaisedFilter,
    tierValue,
    cityValue,
    collegeValue,
    roleValue,
    createdAtStart,
    createdAtEnd,
    lastDate,
    offerAppliedFilter,
    offerAppliedFilter,
    clearDate,
    clearJoiningDate,
  ])
  /**
   * https://pluginlivedevelopment.atlassian.net/browse/PLUG-2059 by Jothi
   */
  const columns = [
    {
      title: 'SR. NO',
      dataIndex: 'id',
      width: '5%',

      render: (text, record, index) => (
        <RowNumberDataReportAlignCenter>
          {serialNo(index, previousPage, currentPage, loadingRole)}
        </RowNumberDataReportAlignCenter>
      ),
      align: 'center',
    },
    {
      title: 'Role',
      width: '20%',
      dataIndex: 'lower(c.tittle)',
      sorter: true,
      render: (_, { tittle }) => (
        <RowNumberDataReport>{tittle}</RowNumberDataReport>
      ),
    },
    {
      title: 'no.of drives',
      dataIndex: 'totaldrive',
      align: 'center',
      sorter: true,
      render: (_, { totaldrive }) => (
        <RowNumberDataReportAlignCenter>
          {totaldrive}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'Application last Date',
      sorter: true,
      dataIndex: 'end_date',
      align: 'center',
      render: (_, { end_date }) => (
        <RowNumberDataReportAlignCenter>
          {DateFormat(end_date)}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'college name',
      dataIndex: 'campus_name',
      sorter: true,
      width: '15%',

      render: (text, record) => {
        if (record.id) {
          return (
            <RowNumberDataReport>
              {record?.campus?.length > 1 ? (
                <>
                  <CustomTag
                    message={record?.campus?.[0]}
                    bordered={true}
                    background="#F2F3F5"
                    colorType="#808697"
                    border="#F2F3F5"
                    pointer={true}
                  />
                  <CustomTag
                    message={`+${record?.campus?.length - 1}`}
                    bordered={true}
                    background="#F2F3F5"
                    colorType="#808697"
                    border="#F2F3F5"
                    pointer={true}
                  />
                </>
              ) : record?.campus?.length === 1 ? (
                <CustomTag
                  message={record?.campus?.[0]}
                  bordered={true}
                  background="#F2F3F5"
                  colorType="#808697"
                  border="#F2F3F5"
                />
              ) : (
                <>-</>
              )}
            </RowNumberDataReport>
          )
        } else {
          let data = record.campus_name
          return data
        }
      },
    },
    {
      title: 'tier',
      dataIndex: 'tier',
      sorter: true,
      align: 'center',
      render: (_, { tier }) => (
        <RowNumberDataReportAlignCenter>{tier}</RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'Students Applied',
      dataIndex: 'totalstudent',
      key: 'totalstudent',
      align: 'center',
      sorter: true,
      render: (_, { totalstudent }) => (
        <RowNumberDataReportAlignCenter>
          {totalstudent}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'Avg Student Ranking',
      dataIndex: 'avgrating',
      key: 'drive Number',
      align: 'center',
      sorter: true,
      render: (_, { avgrating }) => (
        <RowNumberDataReportAlignCenter>
          {Number(avgrating)?.toFixed(2)}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'Offer Made',
      dataIndex: 'offerreleased',
      key: 'drive Number',
      align: 'center',
      sorter: true,
      render: (_, { offerreleased }) => (
        <RowNumberDataReportAlignCenter>
          {offerreleased}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'Offer Accepted',
      dataIndex: 'offeraccepted',
      key: 'drive Number',
      align: 'center',
      sorter: true,
      render: (_, { offeraccepted }) => (
        <RowNumberDataReportAlignCenter>
          {offeraccepted}
        </RowNumberDataReportAlignCenter>
      ),
    },
  ].filter(item => !item.hidden)
  const clickedExcel = data => {
    let excel = true
    getCandidateApplicationStatus(
      5000,
      1,
      setExcelLoading,
      roleNameValue,
      filterData,
      sortBy,
      excel
    )
    setIsExcel(data)
  }

  useEffect(() => {
    if (
      (excelDataForReport?.result && tableData && isExcel == 'excel') ||
      (excelDataForReport?.result && tableData && isExcel == 'pdf')
    ) {
      if (loadingRole) {
        setExcel([])
      } else {
        setExcel(excelData)
      }
    }
  }, [excelDataForReport?.result, loadingRole])
  const handleHover = () => {
    if (rolesPublishedData?.count > 5000) {
      WarningMessage(
        'Note : The Candidate Application Status count should not exceed 5,000 for data export.  Apply filters if necessary'
      )
    }
  }
  const FilterData = [
    {
      id: 2,
      headerName: 'College Name',
      searchValue: searchCollegeValue,
      setSearchValue: setSearchCollegeValue,
      setValue: setCollegeValue,
      value: collegeValue,
      data: collegeData,
      apicall: collegeDetails,
      setLoading: setLoadingCollegeFilter,
      loading: loadingCollegeFilter,
      valueParam: 'id',
      labelParam: 'campus_name',
      divider: false,
      flag: 'CA',
    },
    {
      id: 3,
      headerName: 'Role',
      searchValue: searchRoleValue,
      setSearchValue: setSearchRoleValue,
      setValue: setRoleValue,
      value: roleValue,
      data: roleData,
      apicall: roleDetails,
      setLoading: setLoadingRoleFilter,
      loading: loadingRoleFilter,
      valueParam: 'id',
      labelParam: 'tittle',
      divider: false,
      flag: 'CA',
    },
    {
      id: 4,
      headerName: 'College Tier',
      searchValue: searchTierValue,
      setSearchValue: setSearchTierValue,
      setValue: setTierValue,
      value: tierValue,
      data: tierData,
      apicall: tierDetails,
      setLoading: setLoadingTier,
      loading: loadingTier,
      valueParam: 'tier',
      labelParam: 'tier',
      divider: false,
      flag: 'CA',
    },

    {
      id: 5,
      headerName: 'Offer Raised',
      statusFilters: offerRaisedFilter,
    },
    {
      id: 6,
      headerName: 'Offer Accepted',
      statusFilters: offerAppliedFilter,
    },

    {
      id: 7,
      headerName: 'Application Last Date',
      setCreatedAtStart: setLastDate,
      setCreatedAtEnd: setLastDate,
      clearDate: setClearJoiningDate,
      clear: clearJoiningDate,
    },
    {
      id: 1,
      headerName: 'Date Range',
      setCreatedAtStart: setCreatedAtStart,
      setCreatedAtEnd: setCreatedAtEnd,
      clearDate: setClearDate,
      clear: clearDate,
    },
  ]
  const onStatusFilterChanges = (name, status) => {
    const filterValue = status.length ? [status[status.length - 1]] : []
    if (name === 'Offer Raised') {
      setOfferRaisedFilter(filterValue)
    } else if (name === 'Offer Accepted') {
      setOfferAppliedFilter(filterValue)
    }
  }

  const permission = useSelector(state => state?.auth?.permissions)
  const subEvents = permittedSubEvents(
    permission,
    'REPORTS',
    'Candidates Application Status'
  )
  return (
    <>
      {' '}
      <PageContent
        corporateName={corporateData?.name}
        columnWidths={[20, 50, 25, 25, 50, 15, 29, 25, 20, 25, 25]} // Array of column widths
        columnFontSize={10} // Font size for the column data
        HAlign={[
          'center',
          'left',
          'center',
          'center',
          'left',
          'center',
          'center',
          'right',
          'center',
          'center',
        ]}
        pdfCellWidth={27}
        filterData={FilterData}
        cityData={cityData}
        cityDetails={cityDetails}
        pageHeader="Candidate Application Status"
        hasProp={hasData(filterData)}
        column={columns}
        tableData={rolesPublishedData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        onPageChange={onPageChange}
        setSearchRoleValue={setRoleNameValue}
        searchRoleValue={roleNameValue}
        applyFilter={applyFilter}
        clearFilter={clearFilter}
        onChange={onSorting}
        width={'100'}
        loadingRole={loadingRole}
        loadingTier={loadingTier}
        tooltip={tooltip}
        handleHover={handleHover}
        clickedExcel={clickedExcel}
        excel={excel}
        isExcel={isExcel}
        setIsExcel={setIsExcel}
        excelLoading={excelLoading}
        createdAtStart={createdAtStart}
        createdAtEnd={createdAtEnd}
        setCreatedAtStart={setCreatedAtStart}
        setCreatedAtEnd={setCreatedAtEnd}
        onStatusFilterChanges={onStatusFilterChanges}
        setAppendDateFilter={setAppendDateFilter}
        appendDateFilter={appendDateFilter}
        clearDate={clearDate}
        setClearDate={setClearDate}
        setDateError={setDateError}
        subEvents={subEvents}
      />
    </>
  )
}
export default CandidateApplication
